import { render } from "./TicketsList.vue?vue&type=template&id=4b3fb36b"
import script from "./TicketsList.vue?vue&type=script&lang=js"
export * from "./TicketsList.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "4b3fb36b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b3fb36b', script)) {
    api.reload('4b3fb36b', script)
  }
  
  module.hot.accept("./TicketsList.vue?vue&type=template&id=4b3fb36b", () => {
    api.rerender('4b3fb36b', render)
  })

}

script.__file = "src/views/support/modules/tickets/TicketsList.vue"

export default script